import React, {useState} from 'react';
import WeexInput from '../../comps/WeexInput';
import WeexModal from '../../comps/weexModais/WeexModal';
import { Link, useHistory } from 'react-router-dom';
import UsuarioService from '../../services/UsuarioService'
import CampanhaService from '../../services/CampanhaService'
import AgendaService from '../../services/AgendaService'
import {useStore} from 'react-redux';



function LoginCampaign(props) {

    const [credenciais, setCredenciais] = useState({username:null, password:null, campaign:props.campanha.code})
    const [processando, setProcessando] = useState(false)
    const [erro, setErro] = useState(null)
    const history = useHistory()

    const campanhaService = new CampanhaService()
	const eventoCorrente = campanhaService.campanhaCorrente()


    
	
	if (! eventoCorrente || ! eventoCorrente.tipoInscricao) {
		campanhaService.clearAll()
		if (! window.location.href.endsWith("select")) {
			window.location = "/select"
		}
	}

    const tipoInscricao = eventoCorrente.tipoInscricao
    const elegibilidade = eventoCorrente.restrictEligibility
    const nomeMatricula = eventoCorrente.nomeMatricula;
    const obrigatoriedadeDoTermoCampanha = eventoCorrente.legalTerm;
    const requiredInterests = eventoCorrente.requiredInterests;

    const i18n = useStore().getState().i18n; 

    const possuiCampo = (campo) => {
        let possui = false;
        for(let i=0; i<eventoCorrente.fields.length; i++){
            if(eventoCorrente.fields[i].field === campo){
                possui = true
            }
        }
        return possui
    }

    const rotuloDoCampo = (campo) => {
        let rotulo = '';
        for(let i=0; i<eventoCorrente.fields.length; i++){
            if(eventoCorrente.fields[i].field === campo){
                if(eventoCorrente.nomeMatricula){
                    rotulo = eventoCorrente.nomeMatricula
                } else {
                    rotulo = eventoCorrente.fields[i].label
                }
            }
        }
        return rotulo
    }

    const submit = (event) => {
        
        event.preventDefault()
        if (processando) {
            return
        }
        setProcessando(true)
        const service = new UsuarioService()
        service.auth(credenciais, (erro, sucesso) => {
            if (erro) {
                let mensagemInscricao = '';
                let temSenha = true;
                if(eventoCorrente.tipoInscricao !== 'CUSTOMIZADO'){
                    mensagemInscricao = eventoCorrente.tipoInscricao === 'EMAIL' ? 'e-mail' : nomeMatricula;
                }else{
                    if(possuiCampo('MATRICULA')){
                        mensagemInscricao = rotuloDoCampo('MATRICULA')
                    }else if(possuiCampo('EMAIL')){
                        mensagemInscricao = rotuloDoCampo('EMAIL')
                    }else{
                        mensagemInscricao = 'login'
                    }

                    if (!possuiCampo('SENHA')) {
                        temSenha = false;
                    }
                }
                let mensagemPadrao = "Verifique seu " + mensagemInscricao + " e senha e tente novamente."
                if(eventoCorrente.restrictEligibility || !temSenha){
                    mensagemPadrao = "Verifique seu " + mensagemInscricao + " e tente novamente."
                }
                
                setErro({
                    titulo:i18n.message("login.erro.denied.titulo", "Acesso negado"), 
                    mensagem:i18n.message("login.erro.denied.mensagem", mensagemPadrao)
                })
                setProcessando(false)
                return
            }
            if (sucesso) {
                setProcessando(false)

                if(tipoInscricao === "ELEGIBILIDADE" && obrigatoriedadeDoTermoCampanha === true && !sucesso.legalTerm){
                    history.push("/accept")
                } else{
                    campanhaService.contadorCampanha((erro, sucesso)=>{
                        if(erro){
                            setErro({
                                titulo: i18n.message("atividades.erro.dias.habilitados", "Erro obter lista de dias habilitados")
                            })
                            return;
                        }
                        if(sucesso){
                            if(sucesso !== null){
                                if(sucesso.length > 0 ){
                                    history.push('/atividades')
                                } else {
                                    history.push("/home")
                                }
                            }
                        }
                    })
                }
                props.callbackLogin(sucesso)
            }
        })
    }

    const onChange = (event) => {
        let cred = credenciais
        cred[event.target.name] = event.target.value
        setCredenciais(cred)
    }

    const callbackWarning = () => {
        setErro(null)
    }

    return (
        <form style={{width:'100%'}} onSubmit={submit}>
            {
                tipoInscricao === 'EMAIL' 
                ? 
                    (<WeexInput type="email" name="username" label={i18n.message("registro.campo.email", "E-mail")} required={true} onChange={onChange}/>)
                :   
                    (tipoInscricao !== 'CUSTOMIZADO') 
                    ?
                    (<WeexInput type="text" name="username" label={nomeMatricula} required={true} onChange={onChange}/>)
                    : 
                        possuiCampo('MATRICULA')
                        ?
                        (<WeexInput type="text" name="username" label={rotuloDoCampo('MATRICULA')} required={true} onChange={onChange}/>)
                        :
                        (<WeexInput type="email" name="username" label={rotuloDoCampo('EMAIL')} required={true} onChange={onChange}/>)
            }

            {
                !elegibilidade && (tipoInscricao !== 'CUSTOMIZADO' || possuiCampo('SENHA')) 
                ? 
                    (tipoInscricao !== 'CUSTOMIZADO')
                    ?
                        (<WeexInput type="password" name="password" label={i18n.message("registro.campo.senha", "Senha")} required={true} onChange={onChange}/>)
                    :
                        (<WeexInput type="password" name="password" label={rotuloDoCampo('SENHA')} required={true} onChange={onChange}/>)
                : 
                    null
            }

            <p style={{textAlign:'center'}}>
                
            {
                erro != null ? (
            
                <WeexModal callback={callbackWarning} visivel={erro != null} titulo={erro.titulo} conteudo={erro.mensagem}/>
            
                ) : null
            }
                
            <input className="weex-button" type="submit" value={processando ? i18n.message("geral.aguarde", "Aguarde...") : i18n.message("login.entrar", "Entrar")}/>
            {
                (elegibilidade && tipoInscricao !== 'ELEGIBILIDADE') ? (
                    <>
                    <br/><br/>
                    <Link to="/registerSelector">{i18n.message("registro.inscrevase", "Inscreva-se")}</Link>
                    </>
                ) : null
            }
            {
                (tipoInscricao !== 'MATRICULA' && !elegibilidade) ? (
                    <>
                    <br/><br/>
                    <Link to="/resetPassword">{i18n.message("registro.resetsenha", "Esqueci minha senha")}</Link>
                    </>
                ) : null
            }
            </p>
        </form>
    )
}

export default LoginCampaign;